import React from 'react';
import "./LoadingDeer.less"
const LoadingDeer: React.FC = () => {
    const containerStyle: React.CSSProperties = {
        // position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#ff218900',
        zIndex: 9999,
    };

    const svgStyle: React.CSSProperties = {
        width: '120px',
        height: 'auto',
        display: 'block',
        overflow: 'visible',
    };

    return (
        <div style={containerStyle}>
            <svg
                style={svgStyle}
                viewBox="20.54 0.01 55.52 79.98"
                xmlns="http://www.w3.org/2000/svg"
            >

                <g>
                    <path className="deer-line" d="M64.29,29.31c-.55,.78-1.3,1.61-4.39,3.41-5.08,2.96-8.94,2.96-10.7,6.96,0,0,.22,.22-.04,.75,0,0,1.23,.52,2.74,2.39,0,0,2.34-.06,3.19,.56,0,0,3.97,.14,4.21,.39,.24,.26,.14,.47-.38,1.11-.51,.64-1.49,.05-1.8,.73-.32,.67-2.96,1.23-2.96,1.23,.03,2.69,5.63,3.47,9.79,6.15,0,0-3.5,18.72-15.56,9.25-2.8-2.62-3.52-6.44-4.68-6.48-1.16-.03-5.87,.9-7.3,.79-1.42-.11-1.65,.97-4.3,.94-2.66-.04-2.02-.68-2.02-.68,0,0-1.76-.11-1.76-2.58s.67-.75,6.47-6.03c0,0,1.09-1.46,1.42-1.72,0,0,.04-1.68,.79-2.17,.75-.49,1.91-.97,2.17-1.16,.26-.19,1.12-.6,1.05-1.2-.07-.6-.26-.04-.49-.37-.22-.34-.07-.9-.26-2.47-.19-1.57-4.75-4.9-5.46-7.41-.71-2.51,1.97,2.2,3.5,2.46,1.54,.26,3.72,.38,3.61-2.42-.09-2.31,.42-4.47-.23-6.39-11.76,3.07-20.36,13.42-20.36,26.85,0,16.11,12.37,27.79,27.72,27.79s27.8-11.68,27.8-27.79c0-9.84-4.64-18.01-11.75-22.9Z" />
                    <path className="deer-line" d="M40.88,25.35c1.44-.38,3.08-.65,4.6-.81-.28,.61-.49,1.22-.56,1.85,0,0-.72,2.82-.79,5.68-.07,2.85-.86,5.63-.6,5.85,.26,.23,.75,.08,.64,.82l.95-.61,.51-.03,2.07-1.63c-.15-1.08-1.23-2.21-1.12-4.23,.11-2.02,1.68-6.92,1.98-6.92,0,0-.82,5.46,.08,7,.9,1.53,1.27,1.87,2.06,1.31,.78-.56,1.94-.52,2.43-.86,.48-.33,6.11-1.67,8.4-5.12-3.95-2.08-8.49-3.23-13.31-3.23-.93,0-1.85,.04-2.75,.13,.68-1.71,1.95-3.3,2.9-5.02,1.21-2.21,.39-1.16,1.53-4.41,1.14-3.25,1.34-2.39,2.23-3.98,1.92-3.75,3-5.11,3-5.11l-4.44,4.17s-.6-.05-.46-3.54c.13-3.38,.93-6.46,.97-6.65-.13,.26-2.82,5.92-3.35,13.04-.53,7.28-4.85,9.21-4.85,9.21,0,0-3.36,.58-4.3-5.55-.92-5.98,.86-8.82,.95-8.96-.1,.1-2.02,2.19-2.45,5.82-.44,3.72,1.42,7.86,2.96,10.15,.37,.55,.55,1.05,.7,1.64Z" />
                    <path className="deer-line" d="M61.79,27.3c-.08,.13-.15,.21-.24,.34,.96,.5,1.85,1.06,2.74,1.66,.47-.62,.69-1.11,1.58-1.96,1.93-1.85,4.45-5.02,5.66-6.72,1.21-1.7,2.49-4.9,2.68-7.28,0-.05,0-.11,0-.16,1.15-3.78,2.21-8.06,.88-9.15,0,0,.92,1.86-1.29,4.03-.21-7.37-.99-7.51-.99-7.51,0,0-1.17,9.73-.87,10.9,.31,1.17-.38,2.94-1.73,5.77-1.36,2.83-4.79,8.49-6.68,7.32-1.88-1.17-2.53-2.21-2.56-4.7-.04-2.49-.68-3.19-.68-3.19,0,0-.83,5.51,.3,7.36,1.13,1.85,1.21,3.28,1.21,3.28Z" />
                </g>
            </svg>
        </div>
    );
};

export default LoadingDeer;